import React from "react";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon";
import StructuredText from "../custom-structured-text-renderer";
import { RightArrow, Download, BoneLogoWhite, WoodsLogo, EdlynLogo, GreenWheatLogo, Checked, Years95Ver2 } from "../../icons";
import AnimationButton from "./animation-button";

const ProductCta = ({title, richContent, list, button, image, video, theme, special}) => {

  return (
    <section className={`product-cta ${theme || ''}${list?.length > 0 ? ' product-cta--single' : ''}${special ? ' special edlyn' : ''}`}>
      <div className="product-cta__inner">
        <div className="product-cta__wrapper">
          <div className="product-cta__content">
            <div className='product-cta__logo'>
              { !list?.length > 0 && special &&
              <>
                {(theme === 'edlyn' || special) && <EdlynLogo/>}
                {theme === 'bone' && <BoneLogoWhite/>}
                {theme === 'greenwheat' && <GreenWheatLogo/>}
                {theme === 'woods' && <WoodsLogo/>}
                { special && <Years95Ver2/> }
              </>
              }
            </div>
            <div className="product-cta__content-inner">
              {title && <h2>{parse(title)}</h2>}
              {richContent && <StructuredText data={richContent}/>}
              {list?.length > 0 &&
                <ul className='product-cta__list'>
                  {list.map((item, i) => (
                    <li key={i}>
                      <span><Checked /></span>{item.title}
                    </li>
                  ))}
                </ul>
              }
              {list?.length > 0 && button?.length > 0 && !special &&
                <AnimationButton
                  className={`btn btn--animation ${theme === 'bone' ? 'btn--brown' : ''}`}
                  to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink?.permalink}>
                    {button[0].title}
                </AnimationButton>
              }
              {button?.length > 0 && list.length <= 0 && !special &&
                <Link
                  className='wide-button'
                  to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink.permalink}
                  target="_blank"
                  rel="noopener noreferrer">
                  {button[0].title}
                  <Download color="#ffffff"/>
                </Link>
              }
              {button?.length > 0 && special &&
                <Link
                  className='wide-button'
                  to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink.permalink}
                  target="_blank"
                  rel="noopener noreferrer">
                  {button[0].title}
                  <RightArrow color="#ffffff"/>
                </Link>
              }
            </div>
          </div>
          <div className="product-cta__image" >
            {image && !video && <Asset asset={image}/> }
            {video && <video src={video} autoPlay loop muted playsInline/> }
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductCta

export const query = graphql`
fragment ProductCtaProps on DatoCmsProductCta {
  ... on DatoCmsProductCta {
    title
    richContent {
      value
    }
    list {
      title
    }
    button {
      ...LinkWithTitleProps
    }
    image {
      ...InternalAssetProps
    }
    video
    special
  }
}
`